export default {
  TEXT: '0',
  EMAIL: '1',
  WHATS_APP: '2',
  ALL: '3', // user may have specified 1 or more recovery methods (new option in an AB test)
}
